// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-form .link {\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n}\n.login-form .link a {\n  text-decoration: none;\n}\n.login-form .form-text {\n  margin: 10px 0;\n  color: rgba(0, 0, 0, 0.609);\n}", ""]);
// Exports
module.exports = exports;
